import React from 'react';
import { MessageSquare, Phone } from 'lucide-react';
import { business } from '../data/business';
export function StickyCallBar() {
  return <div className="fixed bottom-0 left-0 right-0 z-50 flex gap-3 border-t border-brand-navy/10 bg-white p-3 sm:hidden" data-id="element-197" data-mp="1zy9ybhpz5zx7">
      <a href={business.phoneHref} className="flex flex-1 items-center justify-center gap-2 rounded-full bg-brand-blue py-3.5 text-sm font-bold text-white" data-id="element-198" data-mp="1vvlnj4hpaixl">
        <Phone className="h-4 w-4" aria-hidden="true" data-id="element-199" data-mp="2nocmhmqrqlqj" />
        Call Now
      </a>
      <a href="#quote" className="flex flex-1 items-center justify-center gap-2 rounded-full bg-brand-navy py-3.5 text-sm font-bold text-white" data-id="element-200" data-mp="2jo275jh36iz0">
        <MessageSquare className="h-4 w-4" aria-hidden="true" data-id="element-201" data-mp="29q5xyx7ply3j" />
        Free Estimate
      </a>
    </div>;
}